import React, { useState } from 'react';
import posthog from 'posthog-js';

import { getPreSignedS3Url } from '../../../../libs/fetch.js';
import { primaryButtonClasses } from '../../../../libs/sharedClassNames.js';
import { delay } from '../../../../libs/utils.js';

const FileUpload = ({ connectionDataSourceId, updateFileHistory }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState([]);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
    setUploadStatus(selectedFiles.map((file) => ({ name: file.name, status: 'pending' })));
    posthog.capture('file_upload_selector_clicked');
  };

  const handleUpload = async () => {
    if (!files.length) {
      alert('Please select files to upload');
      return;
    }

    setUploading(true);
    const newUploadStatus = [...uploadStatus];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      try {
        newUploadStatus[i] = { name: file.name, status: 'uploading' };
        setUploadStatus([...newUploadStatus]);

        const { data, error } = await getPreSignedS3Url(connectionDataSourceId, file.name);

        if (error) {
          newUploadStatus[i] = { name: file.name, status: `Error: ${error.message}` };
        } else {
          const { presigned_url } = data;
          const response = await fetch(presigned_url, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
            },
            body: file,
          });

          if (!response.ok) {
            newUploadStatus[i] = { name: file.name, status: 'Upload failed' };
          } else {
            newUploadStatus[i] = { name: file.name, status: 'Success' };
          }
        }
      } catch (e) {
        newUploadStatus[i] = { name: file.name, status: `Unexpected error: ${e.message}` };
      } finally {
        setUploadStatus([...newUploadStatus]);
        await updateFileHistory();
        posthog.capture('customer_file_uploaded');

        await delay(5000);
      }
    }

    setUploading(false);
    setFiles([]);
  };

  return (
    <>
      <div>
        <input
          className="mb-1"
          type="file"
          multiple
          onChange={handleFileChange}
        />
        <button
          className={primaryButtonClasses}
          onClick={handleUpload}
          disabled={uploading}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>

        <ul>
          {uploadStatus.map((file, index) => (
            <li key={index} style={{ color: file.status === 'Success' ? 'green' : file.status.includes('Error') || file.status === 'Upload failed' ? 'red' : 'black' }}>
              {file.name}: {file.status}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default FileUpload;
